import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/code-callback',
    name: 'oidc-callback',
    component: () => import('../views/OidcLogin.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/OidcLogout.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
